import { render } from "./FabryLeukocytes.vue?vue&type=template&id=2c6bb08d&scoped=true"
import script from "./FabryLeukocytes.vue?vue&type=script&lang=js"
export * from "./FabryLeukocytes.vue?vue&type=script&lang=js"

import "./FabryLeukocytes.vue?vue&type=style&index=0&id=2c6bb08d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6bb08d"]])

export default __exports__